
// import * as api from '../api/index'

// import { AUTH, CREATE_PROFILE ,FETCH_USERS,START_LOADING,END_LOADING, DELETE_USER,UPDATE_USER} from './constants'


// export const getUsers = () => async (dispatch) => {
//     try {
  
//       dispatch({ type: START_LOADING })
//       const { data } = await api.fetchUsers();
    
//       //  console.log(data.email)
//       dispatch({ type: FETCH_USERS, payload: data });
//       dispatch({ type: END_LOADING })
  
//     } catch (error) {
//       console.log(error);
//     } };

// export const deleteUser = (id, openSnackbar) => async (dispatch) => {
//   try {
//     await api.deleteUser(id);
//     dispatch({ type: DELETE_USER, payload: id });
//     openSnackbar("User deleted successfully");
//   } catch (error) {
//     console.log(error);
//   }
// };
// export const updateUser = (id, form, openSnackbar) => async (dispatch) => {
//     try {
//       // Toggle the isActive value
//       const { data } = await api.updateUser(id, form);
//       dispatch({ type: UPDATE_USER, payload: data });
//       openSnackbar("User updated successfully");
//     } catch (error) {
//       console.log(error);
//     }
//   };
  
// // export const adminSignin =(formData, openSnackbar, setLoading) => async(dispatch) => {

// //     try {
// //         //login the user
// //         const { data } = await api.adminSignIn(formData)
// //         (data)
// //         dispatch({ type: AUTH, data})
// //         // const { info } = await api.createProfile({name: data?.result?.name, email: data?.result?.email, userId: data?.result?._id, phoneNumber: '', businessName: '', contactAddress: '', logo: '', website: ''});
// //         // dispatch({ type: CREATE_PROFILE, payload: info });
// //             // setLoading(false)
// //         openSnackbar("Admin Signin successfull")
// //         // history.push('/dashboard')
// //         window.location.href="/adminDashboard"

// //     } catch (error) {
// //          console.log(error?.response?.data?.message)
// //         openSnackbar(error?.response?.data?.message)
// //         setLoading(false)
// //     }
// // }





// export const signup =(formData, openSnackbar, setLoading) => async(dispatch) => {

//     try {
//         //Sign up the user
//         const { data } = await api.signUp(formData)
//         // dispatch({ type: AUTH, data})
//         const { info } = await api.createProfile({name: data?.result?.name, email: data?.result?.email, userId: data?.result?._id, phoneNumber: '', businessName: '', contactAddress: '', logo: '', website: ''});
//         dispatch({ type: CREATE_PROFILE, payload: info });
        
//       setTimeout(() => {
//           window.location.reload();
//       }, 1000);
//         // history.push('/dashboard')
//         openSnackbar("Sign up successfull")

//     } catch (error) {
//         console.log(error)
//         openSnackbar(error?.response?.data?.message)
//         setLoading(false)
//     }
// }



// export const forgot =(formData) => async(dispatch) => {
//     try {
//         await api.forgot(formData)
//     } catch (error) {
//         console.log(error)
//     }
// }


// export const reset =(formData, history) => async(dispatch) => {

//     try {
//         await api.reset(formData)
//         history.push('/login')

//     } catch (error) {
//         alert(error)
//     }
// }
//----------------------------------------------------------------

import * as api from '../api/index';
import { AUTH, CREATE_PROFILE, FETCH_USERS, START_LOADING, END_LOADING, DELETE_USER, UPDATE_USER, FETCH_USER_TYPES, CREATE_USER_TYPE, UPDATE_USER_TYPE, DELETE_USER_TYPE } from './constants';

export const getUsers = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchUsers();
    dispatch({ type: FETCH_USERS, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log("Error fetching users:", error);
  }
};

export const deleteUser = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteUser(id);
    dispatch({ type: DELETE_USER, payload: id });
    openSnackbar("User deleted successfully");
  } catch (error) {
    console.log(error);
  }
};

// export const signin =(formData, openSnackbar, setLoading) => async(dispatch) => {

//   try {
//       //login the user
//       const { data } = await api.signIn(formData)
//       //
//       dispatch({ type: AUTH, data})
//       // const { info } = await api.createProfile({name: data?.result?.name, email: data?.result?.email, userId: data?.result?._id, phoneNumber: '', businessName: '', contactAddress: '', logo: '', website: ''});
//       // dispatch({ type: CREATE_PROFILE, payload: info });
//           // setLoading(false)
//           window.location.href="/PosMainScreen"
//       openSnackbar("Signin successfull")
//       // history.push('/dashboard')
      
      

//   } catch (error) {
//        console.log(error?.response?.data?.message)
//       openSnackbar(error?.response?.data?.message)
//       setLoading(false)
//   }
// }

// export const signin = (formData, openSnackbar, setLoading) => async (dispatch) => {
//   try {
//     const { data } = await api.signIn(formData);
//     dispatch({ type: AUTH, data });
//     localStorage.setItem("profile", JSON.stringify(data)); // Save full response
//     window.location.href = "/PosMainScreen";
//     openSnackbar("Signin successful");
//   } catch (error) {
//     console.log(error?.response?.data?.message);
//     openSnackbar(error?.response?.data?.message || "Signin failed");
//     setLoading(false);
//   }
// };

// export const signin = (formData, openSnackbar, setLoading) => async (dispatch) => {
//   try {
//     const { data } = await api.signIn(formData);

//     dispatch({ type: "AUTH", data });

//     // SUPER ADMIN REDIRECT
//     if (data?.result?.userType?.includes("superAdmin")) {
//       window.location.href = "/Subscribers";
//       return data;
//     }

//     // NORMAL USER REDIRECT
//     // window.location.href = "/PosMainScreen";
//     return data;

//   } catch (error) {
//     setLoading(false);
//     if (error.response) {
//       return { expired: true, message: error.response.data.message };
//     }
//     throw error;
//   }
// };

// export const signin = (formData, openSnackbar, setLoading) => async (dispatch) => {
//   try {
//     const { data } = await api.signIn(formData);

//     dispatch({ type: "AUTH", data });

//     // SUPER ADMIN REDIRECT
//     if (data?.result?.userType?.includes("superAdmin")) {
//       window.location.href = "/Subscribers";
//       return data;
//     }

//     return data; // NORMAL USER
//   } catch (error) {
//     setLoading(false);

//     // Server responded with an error
//     if (error.response) {
//       const msg = error.response.data.message;

//       // 🔥 IF EXPIRY ERROR → send to login page
//       if (msg?.toLowerCase()?.includes("expiry") || msg?.toLowerCase()?.includes("expired")) {
//         window.location.href = "/login";
//         return { expired: true, message: msg };
//       }

//       // 🔥 ANY OTHER ERROR → show snackbar
//       openSnackbar(msg || "Something went wrong");
//       return { error: true, message: msg };
//     }

//     throw error;
//   }
// };

// export const signin = (formData, openSnackbar, setLoading) => async (dispatch) => {
//   try {
//     const { data } = await api.signIn(formData);

//     dispatch({ type: "AUTH", data });

//     // SUPER ADMIN → redirect immediately
//     if (data?.result?.userType?.includes("superAdmin")) {
//       window.location.href = "/Subscribers";
//       return data;
//     }

//     // NORMAL USER → return data for further UI handling
//     return data;

//   } catch (error) {
//     setLoading(false);

//     if (error.response) {
//       const msg = error.response.data.message || "";

//       // SUPER ADMIN login → show snackbar only for invalid credentials
//       const isSuperAdminLogin = formData?.email?.toLowerCase() === "superadmin@gmail.com";
//       if (isSuperAdminLogin) {
//         openSnackbar(msg);
//         return { error: true, message: msg };
//       }

//       // NORMAL USER → redirect to login if subscription expired
//       if (msg.toLowerCase().includes("expiry") || msg.toLowerCase().includes("expired")) {
//         window.location.href = "/login";
//         return { expired: true, message: msg };
//       }

//       // NORMAL errors (invalid credentials etc.)
//       openSnackbar(msg);
//       return { error: true, message: msg };
//     }

//     throw error;
//   }
// };


export const signin = (formData, openSnackbar, setLoading) => async (dispatch) => {
  try {
    const { data } = await api.signIn(formData);

    dispatch({ type: "AUTH", data });

    const userType = data?.result?.userType; // array

    // SUPER ADMIN → direct redirect
    if (Array.isArray(userType) && userType.includes("superAdmin")) {
      window.location.href = "/Subscribers";
      return data;
    }

    return data;

  } catch (error) {
    setLoading(false);

    if (error.response) {
      const msg = error.response.data.message || "";
      const lower = msg.toLowerCase();

      const isSuperAdminLogin =
        formData?.email?.toLowerCase() === "superAdmin@gmail.com";

      // SUPER ADMIN wrong password → SHOW SNACKBAR but DO NOT treat as expired
      if (isSuperAdminLogin) {
        openSnackbar(msg);
        return { error: true, message: msg };
      }

      // 🚫 IMPORTANT: Only normal users should be treated as expired
      const isExpired =
        lower.includes("expiry") ||
        lower.includes("expired") ||
        lower.includes("assistance") ||
        lower.includes("contact support");

      if (isExpired) {
        return { expired: true, message: msg };
      }

      // Other normal errors
      openSnackbar(msg);
      return { error: true, message: msg };
    }

    throw error;
  }
};





export const updateUser = (id, form, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateUser(id, form);
    dispatch({ type: UPDATE_USER, payload: data });
    openSnackbar("User updated successfully");
  } catch (error) {
    console.log(error);
  }
};

// export const adminSignup = (formData, openSnackbar, setLoading) => async (dispatch) => {
//   try {
//     console.log('Admin Sign up Calling Action');
//     const { data } = await api.adminSignUp(formData);
//     const { info } = await api.createProfile({ name: data?.result?.name, email: data?.result?.email, userId: data?.result?._id, phoneNumber: '', businessName: '', contactAddress: '', logo: '', website: '' });
//     dispatch({ type: CREATE_PROFILE, payload: info });
//     openSnackbar("Sign up successful");
//     setTimeout(() => {
//       window.location.reload();
//     }, 2000);
//   } catch (error) {
//     console.log(error);
//     openSnackbar(error?.response?.data?.message);
//     setLoading(false);
//   }
// };

export const adminSignup =(formData, openSnackbar, setLoading) => async(dispatch) => {

  try {
      //Sign up the user (server creates user + profile)
      console.log('Admin Sign up Calling Action')
      const { data } = await api.adminSignUp(formData)
      if (data?.userProfile) {
        dispatch({ type: CREATE_PROFILE, payload: data.userProfile });
      }
      openSnackbar("User created successfully")
      setTimeout(() => {
        window.location.reload();
      }, 2000);

  } catch (error) {
      console.log(error)
      openSnackbar(error?.response?.data?.message || "Failed to create user")
      setLoading(false)
  }
}

export const fetchUserTypes = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    console.log("Fetching user types..."); // Debug log
    const { data } = await api.fetchUserTypes();
    console.log("Fetched user types:", data); // Debug log
    dispatch({ type: FETCH_USER_TYPES, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.error("Error fetching user types:", error.message); // Detailed error log
    dispatch({ type: END_LOADING });
    dispatch({ type: FETCH_USER_TYPES, payload: [] }); // Fallback to empty array
  }
};

export const createUserType = (userTypeData, openSnackbar) => async (dispatch) => {
  try {
    console.log("Dispatching createUserType with data:", userTypeData); // Debug
    const { data } = await api.createUserType(userTypeData);
    
    console.log("createUserType response:", data); // Debug
    dispatch({ type: CREATE_USER_TYPE, payload: data });
    dispatch(fetchUserTypes());
    openSnackbar("User type created successfully");
  } catch (error) {
    console.log("Error creating user type:", error.response?.data || error); // Debug
    openSnackbar(error?.response?.data?.message || "Failed to create user type");
  }
};

export const updateUserType = (name, userTypeData, openSnackbar) => async (dispatch) => {
  try {
    console.log("Dispatching updateUserType for:", name); // Debug
    const { data } = await api.updateUserType(name, userTypeData);
    dispatch({ type: UPDATE_USER_TYPE, payload: data });
    openSnackbar("User type updated successfully");
  } catch (error) {
    console.log("Error updating user type:", error);
    openSnackbar(error?.response?.data?.message || "Failed to update user type");
  }
};

export const deleteUserType = (name, openSnackbar) => async (dispatch) => {
  try {
    console.log("Dispatching deleteUserType for:", name); // Debug
    await api.deleteUserType(name);
    dispatch({ type: DELETE_USER_TYPE, payload: name });
    dispatch(fetchUserTypes()); // Refresh list
    openSnackbar("User type deleted successfully");
  } catch (error) {
    console.log("Error deleting user type:", error);
    openSnackbar(error?.response?.data?.message || "Failed to delete user type");
  }
};

// export const updateUserType = async (req, res) => {
//   const { name } = req.params;
//   const { permissions, active } = req.body;
//   try {
//     console.log("Raw request body received:", req.body);
//     const userType = await UserType.findOne({ name });
//     if (!userType) {
//       console.log("User type not found:", name);
//       return res.status(404).json({ message: "User type not found" });
//     }
//     if (permissions) {
//       userType.permissions = {
//         pages: permissions.pages || userType.permissions.pages,
//         canApplyCustomDiscount: permissions.canApplyCustomDiscount ?? userType.permissions.canApplyCustomDiscount,
//       };
//     }
//     if (active !== undefined) userType.active = active;
//     const updatedUserType = await userType.save();
//     if (!updatedUserType) {
//       console.error("Update failed - no document returned");
//       return res.status(500).json({ message: "Failed to update user type" });
//     }
//     console.log("Saved to MongoDB:", updatedUserType.toObject());
//     res.set('Cache-Control', 'no-store, no-cache, must-revalidate, private');
//     res.status(200).json(updatedUserType);
//   } catch (error) {
//     console.error("Error updating user type:", error.message, error.stack);
//     res.status(500).json({ message: "Something went wrong" });
//   }
// };

// export const deleteUserType = async (req, res) => {
//   const { name } = req.params;
//   try {
//     console.log("Attempting to delete user type:", name);
//     const activeUsers = await User.find({ userType: name, isActive: true }).select('name email');
//     if (activeUsers.length > 0) {
//       const userList = activeUsers.map(u => u.name).join(", ");
//       console.log(`Cannot delete ${name}: ${activeUsers.length} active users found: ${userList}`);
//       return res.status(400).json({ 
//         message: `${activeUsers.length} active user(s) found (${userList}). Cannot delete this user type.` 
//       });
//     }
//     const result = await UserType.findOneAndDelete({ name });
//     if (!result) {
//       console.log("User type not found:", name);
//       return res.status(404).json({ message: "User type not found" });
//     }
//     console.log("Deleted user type from MongoDB:", result);
//     res.set('Cache-Control', 'no-store, no-cache, must-revalidate, private');
//     res.status(200).json({ message: "User type deleted successfully" });
//   } catch (error) {
//     console.error("Error deleting user type:", error.message, error.stack);
//     res.status(500).json({ message: "Something went wrong" });
//   }
// };


// export const updateUserType = (name, userTypeData, openSnackbar) => async (dispatch) => {
//   try {
//     const { data } = await api.updateUserType(name, userTypeData);
//     dispatch({ type: UPDATE_USER_TYPE, payload: data });
//     openSnackbar("User type updated successfully");
//   } catch (error) {
//     console.log(error);
//     openSnackbar(error?.response?.data?.message);
//   }
// };

// export const deleteUserType = (name, openSnackbar) => async (dispatch) => {
//   try {
//     await api.deleteUserType(name);
//     dispatch({ type: DELETE_USER_TYPE, payload: name });
//     dispatch(fetchUserTypes());
//     openSnackbar("User type deleted successfully");
//   } catch (error) {
//     console.log(error);
//     openSnackbar(error?.response?.data?.message);
//   }
// };

// export const signin = (formData, openSnackbar, setLoading) => async (dispatch) => {
//   try {
//     const { data } = await api.signIn(formData);
//     console.log("Signin response data:", data); // Debug log
//     dispatch({ type: AUTH, data });
//     window.location.href = "/PosMainScreen";
//     openSnackbar("Signin successful");
//   } catch (error) {
//     console.log("Signin error:", error?.response?.data?.message);
//     openSnackbar(error?.response?.data?.message);
//     setLoading(false);
//   }
// };

export const signup = (formData, openSnackbar, setLoading) => async (dispatch) => {
  try {
    const { data } = await api.signUp(formData);
    const { info } = await api.createProfile({ name: data?.result?.name, email: data?.result?.email, userId: data?.result?._id, phoneNumber: '', businessName: '', contactAddress: '', logo: '', website: '' });
    dispatch({ type: CREATE_PROFILE, payload: info });
    setTimeout(() => {
      window.location.reload();
    }, 1000);
    openSnackbar("Sign up successful");
  } catch (error) {
    console.log(error);
    openSnackbar(error?.response?.data?.message);
    setLoading(false);
  }
};

export const forgot = (formData) => async (dispatch) => {
  try {
    await api.forgot(formData);
  } catch (error) {
    console.log(error);
  }
};

export const reset = (formData, history) => async (dispatch) => {
  try {
    await api.reset(formData);
    history.push('/login');
  } catch (error) {
    alert(error);
  }
};